import React from 'react';
import PropTypes from 'prop-types';
import './pagination.css';

function Pagination(props) {
    if (!props.activePage || !props.pages) { return; }

    const resData = [];

    for (let i = 1; i <= props.pages; i++) {
        resData.push(<span className={i === props.activePage ? 'referralStructure__tables_paginationButtonSelected' : 'referralStructure__tables_paginationButton'}
            onClick={ i === props.activePage ? null : props.onClickHandler(i) }>{i}</span>);
    }

    return(<div className="pagination__wrapper">{ resData }</div>)
};

Pagination.propTypes = {
    activePage: PropTypes.number.isRequired,
    pages: PropTypes.number.isRequired,
    onClickHandler: PropTypes.func.isRequired,
};

export default Pagination;
